import { render } from "./VendorsHeader.vue?vue&type=template&id=221e9909"
import script from "./VendorsHeader.vue?vue&type=script&lang=js"
export * from "./VendorsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__